export function scrollToElement(element) {
    element.scrollIntoView({behavior: "smooth", block: "start"});
}

export function cvtTs(UTCTimeStr) {
    if (!UTCTimeStr) {
        return null;
    }
    let useTime = UTCTimeStr;
    if (UTCTimeStr.indexOf("+") === -1) {
        useTime += '+00:00';
    }
    const UTCDate = new Date(useTime);
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const userDateStr = UTCDate.toLocaleString('en-GB', {
        timeZone: userTimeZone,
        dateStyle: 'short',
        timeStyle: 'short'
    });
    return userDateStr;
}

export function cvtTsOnlyTime(UTCTimeStr) {
    if (!UTCTimeStr) {
        return null;
    }
    let useTime = UTCTimeStr;
    if (UTCTimeStr.indexOf("+") === -1) {
        useTime += '+00:00';
    }
    const UTCDate = new Date(useTime);
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (typeof UTCDate.toLocaleTimeString === 'function') {
        return UTCDate.toLocaleTimeString('en-GB', { // en-GB → всегда 24-часовой формат
            timeZone: userTimeZone,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    } else {
        // Фолбэк для старых браузеров
        return `${UTCDate.getHours().toString().padStart(2, '0')}:${UTCDate.getMinutes().toString().padStart(2, '0')}:${UTCDate.getSeconds().toString().padStart(2, '0')}`;
    }
}


export function getTimeZone() {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const offsetMinutes = -new Date().getTimezoneOffset();
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const absOffset = Math.abs(offsetMinutes);
    const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
    const minutes = String(absOffset % 60).padStart(2, '0');
    const offsetStr = `${sign}${hours}:${minutes}`;
    return `${tz} (${offsetStr})`;
}

export function formatTimeRange(duration) {
    if (!duration || duration <= 0) {
        return null;
    }
    const now = new Date();
    // Получаем локальное время пользователя
    const startTime = new Date(now);
    const endTime = new Date(now.getTime() + duration * 60000);
    // Форматируем часы и минуты
    const timeOptions = {hour: '2-digit', minute: '2-digit', hour12: false};
    const startStr = startTime.toLocaleTimeString('default', timeOptions);
    const endStr = endTime.toLocaleTimeString('default', timeOptions);
    // Получаем строку с часовым поясом
    const timeZoneStr = getTimeZone();
    return `${startStr} - ${endStr} (${timeZoneStr})`;
}

export function getDeviceType() {
    // Получаем строку user agent из разных источников
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    // Определение планшетов:
    // - Для iPad, Tablet, PlayBook, Silk
    // - Для Android: если встречается "Android", но не встречается "Mobile" (обычно планшеты)
    if (/iPad|Tablet|PlayBook|Silk/i.test(ua) ||
        (/Android/i.test(ua) && !/Mobile/i.test(ua))) {
        return 'tablet';
    }

    // Определение смартфонов:
    // - Для iPhone, iPod
    // - Для Android: если встречается "Android" вместе с "Mobile"
    // - Для Windows Phone, BB10
    if (/iPhone|iPod|Android.*Mobile|Windows Phone|BB10/i.test(ua)) {
        return 'smartphone';
    }

    // Если ни одно из условий не выполнено, считаем, что устройство – десктоп
    return 'desktop';
}


export function getBrowserName() {
    const userAgent = navigator.userAgent.toLowerCase();
    let browser = "your browser";
    if (userAgent.includes("chrome") || userAgent.includes("chromium")) {
        browser = "Google Chrome";
    } else if (userAgent.includes("firefox")) {
        browser = "Mozilla Firefox";
    } else if (userAgent.includes("safari") && !userAgent.includes("chrome")) {
        browser = "Safari";
    } else if (userAgent.includes("edg")) {
        browser = "Microsoft Edge";
    } else if (userAgent.includes("opera") || userAgent.includes("opr")) {
        browser = "Opera";
    }
    return browser;
}


export async function getShortHash(input) {
    // Преобразуем строку в массив байтов
    const encoder = new TextEncoder();
    const data = encoder.encode(input);

    // Вычисляем SHA-256 хеш
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    // Преобразуем ArrayBuffer в массив байтов
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // Преобразуем байты в шестнадцатеричную строку
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

    // Возвращаем первые 10 символов
    return hashHex.slice(0, 10);
}


/**
 * Переводит браузер в полноэкранный режим (если возможно).
 */
export function enterFullscreen() {
    const elem = document.documentElement; // Полноэкранный режим для всего документа
    let fullScreenFunc;
    if (elem.requestFullscreen) {
        fullScreenFunc = elem.requestFullscreen;
    } else if (elem.mozRequestFullScreen) { // Firefox
        fullScreenFunc = elem.mozRequestFullScreen;
    } else if (elem.webkitRequestFullscreen) { // Chrome, Safari и Opera
        fullScreenFunc = elem.webkitRequestFullscreen;
    } else if (elem.msRequestFullscreen) { // IE/Edge
        fullScreenFunc = elem.msRequestFullscreen;
    }
    if (!fullScreenFunc) {
        return;
    }
    Promise.resolve(fullScreenFunc.call(elem, {navigationUI: "hide"}))
        .catch((err) => {
            console.warn(`An error occurred while trying to switch into fullscreen mode: ${err.message} (${err.name})`);
        });
}

export function getLang() {
    // Получаем путь URL, например: "/en/admin/viewtesturls.html"
    const path = window.location.pathname;
    // Разбиваем путь на части по символу "/"
    const parts = path.split('/');
    // Проверяем, что вторая часть существует и состоит из двух букв
    if (parts.length > 1 && /^[a-z]{2}$/i.test(parts[1])) {
        return parts[1].toLowerCase();
    }
    // Если язык не найден, можно вернуть значение по умолчанию
    return '';
}

export function pickLangHtml(rawValue, lang) {
    if (!rawValue) {
        return '';
    }
    let parsed = null;
    if (typeof rawValue === 'string') {
        const trimmed = rawValue.trim();
        if (!trimmed) {
            return '';
        }
        try {
            parsed = JSON.parse(trimmed);
        } catch (e) {
            return rawValue;
        }
    } else if (typeof rawValue === 'object') {
        parsed = rawValue;
    }

    if (typeof parsed === 'string') {
        return parsed;
    }
    if (parsed && typeof parsed === 'object') {
        const preferred = (lang && parsed[lang]) || parsed.en || parsed.ru;
        return typeof preferred === 'string' ? preferred : '';
    }
    return '';
}
